/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPLAY_OBJ_RATES = 'GET_CURRENT_DISPLAY_OBJ_RATES';
export const GET_PLAN_TYPE_DATA_RATES = 'GET_PLAN_TYPE_DATA_RATES';
export const GET_REBATE_PROGRAM_RATES = 'GET_REBATE_PROGRAM_RATES';
export const GET_REBATE_PROGRAM_NAME_RATES = 'GET_REBATE_PROGRAM_NAME_RATES';
export const GET_ERROR_MSG_RATES = 'GET_ERROR_MSG_RATES';
export const GET_FROM_RATES = 'GET_FROM_RATES';
export const SET_DISPLAY_OBJ_PRO = 'SET_DISPLAY_OBJ_PRO';
export const MANUFACTURER_GRID_RATES = 'MANUFACTURER_GRID_RATES';
export const SET_REFRESH_DATA_RATES = 'SET_REFRESH_DATA_RATES';
export const SET_REFRESH_DATA_RATES_DISPLAY = 'SET_REFRESH_DATA_RATES_DISPLAY';
export const SET_SUPPLEMENTAL_RATES = 'SET_SUPPLEMENTAL_RATES';
export const SET_MANUFACTURER_RATES = 'SET_MANUFACTURER_RATES';
